import React from 'react';
import { useDispatch } from 'react-redux';
import { ContentCopyOutlinedIcon, DeleteOutlinedIcon, EditOutlinedIcon } from 'tuui';
import { deleteLandingPage } from 'modules/landing-pages/flows/deleteLandingPage';
import { useDuplicateLandingPageModal } from 'modules/landing-pages/hooks/useDuplicateLandingPageModal';
import { useOpenEditDrawer } from 'modules/landing-pages/hooks/useOpenEditDrawer';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';
import ActionsCellRenderer from './ActionsCellRenderer';

export const LandingPagesActionsCellRenderer = ({ data }) => {
    const dispatch = useDispatch();
    const { open: openModal } = useModal();
    const openLandingPageEditor = useOpenEditDrawer();
    const { openDuplicateModal } = useDuplicateLandingPageModal();
    const { id: landingPageId, title, accountName, status } = data;

    const handleDelete = async () => {
        const shouldDelete = await openModal({
            title: (
                <FormattedMessage
                    id="landing.pages.delete.confirmation.title"
                    defaultMessage="Delete Landing Page?"
                    tagName="h2"
                />
            ),
            content: (
                <FormattedMessage
                    id="landing.pages.delete.confirmation.message"
                    defaultMessage="You are about to delete landing page: {name}. This action cannot be undone."
                    values={{ name: <b>{title}</b> }}
                />
            ),
            formProps: { submitButtonText: <FormattedMessage id="app.actionButtons.DELETE" /> },
        });

        if (shouldDelete) {
            dispatch(
                deleteLandingPage({
                    accountName,
                    landingPageId,
                })
            );
        }
    };

    const handleDuplicate = () => {
        openDuplicateModal({
            originalTitle: title,
            landingPageId,
            status,
        });
    };

    const buttonConfigs = [
        {
            onClick: () => openLandingPageEditor(data),
            dataMetricComponent: 'EditLandingPageButton',
            icon: <EditOutlinedIcon />,
            iconLabel: 'edit',
            tooltipContent: (
                <FormattedMessage id="landing.pages.report.actions.edit" defaultMessage="Edit Advertorial" />
            ),
        },
        {
            onClick: handleDuplicate,
            dataMetricComponent: 'DuplicateLandingPageButton',
            icon: <ContentCopyOutlinedIcon />,
            iconLabel: 'duplicate',
            tooltipContent: (
                <FormattedMessage id="landing.pages.report.actions.duplicate" defaultMessage="Duplicate Advertorial" />
            ),
        },
        {
            onClick: handleDelete,
            dataMetricComponent: 'DeleteLandingPageButton',
            icon: <DeleteOutlinedIcon />,
            iconLabel: 'delete',
            tooltipContent: (
                <FormattedMessage id="landing.pages.report.actions.delete" defaultMessage="Delete Advertorial" />
            ),
        },
    ];

    return <ActionsCellRenderer buttonConfigs={buttonConfigs} />;
};

export default LandingPagesActionsCellRenderer;
